import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { environment } from 'src/environments/environment';
import { LLMConfigurationDto } from 'src/core/models/llm/llm-configuration.dto';
import { LLMProviderModelListDto } from 'src/core/models/llm/llm-provider-model-list.dto';

@Injectable({
  providedIn: 'root',
})
export class LLMConfigurationService {
  public isNameAvailable(id: number, name: string): Observable<boolean> {
    let encodedName = encodeURIComponent(name);
    const apiUrl = this.getApiUrl(LLMConfigurationDto) + '/' + id + '/' + encodedName;

    return this.http.get(apiUrl) as Observable<boolean>;
  }

  getProxyModelList(apiKey: string, baseUrl: string, configurationId?: number): Observable<LLMProviderModelListDto> {
    const url = this.getApiUrl(LLMProviderModelListDto) + '/proxy';
    let params = new HttpParams().set('baseUrl', baseUrl);
    if (apiKey) {
      params = params.set('apiKey', apiKey);
    }
    if (configurationId) {
      params = params.set('configurationId', configurationId);
    }
    return this.http.get<LLMProviderModelListDto>(url, { params });
  }

  constructor(private http: HttpClient) {}

  protected getApiUrl(type = DtoHasApi): string {
    const apiBase = environment.apis.default.url;

    return apiBase + '/' + type.apiUrl;
  }
}
